import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item", "list"]

  filter() {
    const query = this.inputTarget.value.toLowerCase()
    this.itemTargets.forEach(item => {
      const name = item.dataset.name || ""
      const sku = item.dataset.sku || ""
      item.style.display = (name.includes(query) || sku.includes(query)) ? "" : "none"
    })
  }
}
